import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import { ICurrentCaseByCategory, IProductCategoryContext } from '../../models/case';
import { ProductContextEndpoint } from './product-context-endpoint.service';

@Injectable({
    providedIn: 'root'
})
export class ProductContextService {

    constructor(private caseEndpoint: ProductContextEndpoint) { }


    public getProductContext(tenantId, request: ICurrentCaseByCategory): Observable<IProductCategoryContext> {
        return this.caseEndpoint.getProductContext(tenantId, request);
    }


}
